import { Fancybox } from "@fancyapps/ui";

window.Fancybox = Fancybox; 

Fancybox.bind('[data-fancybox]', {
    Image: {
      zoom: false,
    },
  });